<template>
  <div class="screen-preview-overlay" v-if="isOpen" @click="onClick">
    <div class="screen-container">
      <div class="inner-screen-container">
        <figure class="image is-16by9 centered-screen disable-select">
          <screen
            :idx="screenId"
            :forceOfferId="offerId"
            :forceTemplateId="templateId"
            :forceScreens="screens"
          />
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import Screen from "./screen"

export default {
  name: "screen-preview-overlay",
  components: { Screen },
  props: ["isOpen", "screenId", "offerId", "templateId", "screens"],
  watch: {
    isOpen() {
      if (this.isOpen) {
        document.documentElement.classList.add("is-clipped")
      } else {
        document.documentElement.classList.remove("is-clipped")
      }
    }
  },
  methods: {
    onClick() {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-preview-overlay {
  z-index: 9999;
  background-color: #333;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  & >>> .screen-layout {
    height: 100%;
  }
  .centered-screen {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .screen-container {
    max-height: 100vh;
    height: 100vh;
    max-width: 178vh;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    .inner-screen-container {
      height: 100%;
    }
  }
}
</style>
